import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { conversationListInfiniteQueryOptions } from "~/features/messages/api";
import { MessageListTemplate } from "~/features/messages/MessageListTemplate";
import { ALL_CHAT_TABS } from "~/features/messages/types";

const searchSchema = z.object({
  tab: z.enum(ALL_CHAT_TABS).default("all"),
});

export const Route = createFileRoute("/_authenticated/messages/")({
  validateSearch: searchSchema,
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureInfiniteQueryData(
      conversationListInfiniteQueryOptions("all"),
    ),
  component: MessageListTemplate,
});
